import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import {
  Button,
  Form,
  Input,
  Modal,
  Menu,
  Select,
  Row,
  Col,
  Checkbox,
  Tooltip,
  Radio,
} from "antd";
import {
  DownArrowDraw,
  HaberForm,
  FilteredGrid,
  FilterComp,
} from "../../Pages/styledElements";
import Iconmoon from "../../Components/IconsFiles/icon";
import SearchIcon from "../../Assets/Icons/search.svg";
import { ModalPopup } from "../Modal/modal";
import { createStaticRanges, DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import moment from "moment";
import { getCountries, getCustomers } from "../../Services/customerServices";
import { getAllCutter, getAllRewinder, paperMachineListData } from "../../Services/machineServices";
import {
  getAllGrades,
  getGradeQualities,
} from "../../Services/settingsServices";
import { getProductsData } from "../../Services/productServices";
import { MultiSelect } from "react-multi-select-component";
import OrderFilter from "../OrderFilter/Filter";
import { getUnitData } from "../../Services/measurementService";
import {
  currency_List,lengthUnit,weightUnit 
  } from "../../Utils/Constant/MeasurementUnitList.jsx";
import { RadioButtonStyle, TableList } from "../../Pages/pageStyled.js";
import { getMachineGradeSelectForConfig } from "../../Services/settingsServices.js";
const { Option } = Select;

const MultiSelectHeader = styled.div`
  .dropdown-content {
    max-height: 100px;
  }
  .rmsc .options {
    max-height: 125px;
    color: #000 ;
    font-size: 12px;
    font-family: var(--sf-pro-display-m);
    line-height: 30px !important;
  }
  .rmsc .dropdown-heading .dropdown-heading-value {
    color: #000 ;
    font-size: 12px;
    font-family: var(--sf-pro-display-m);
    line-height: 30px !important;
    height : 35px;
  }
  .rmsc .dropdown-heading {
    height : 35px;
    }

  .rmsc .dropdown-container {
    background-color: var(--form-element-bg);
    border: 2px solid #dfe1e6;
    box-sizing: border-box;
    border-radius: 8px;
  }
`;
const SearchBarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  .dropdown-content {
    max-height: 100px !important;
  }
  .searchBoxWrap {
    display: flex;
    justify-content: space-between;
    padding: 16px 0;
    width: 100%;
  }
  .searchWidth {
    width: 41%;
    .ant-row {
      margin: 0;
    }
    .ant-col {
      input[type="text"] {
        padding-left: 15px !important;
      }
    }
    .searchIcon {
      position: relative;
      &:after {
        content: "";
        position: absolute;
        background-size: contain;
        background-repeat: no-repeat;
        z-index: 2;
        right: 10px;
        top: 12px;
        width: 22px;
        height: 17px;
        background-image: url(${SearchIcon});
      }
    }
  }
  .filterParent {
    display: flex;
    position: relative;
    margin-right: auto;
    margin-left: 30px;

    .filterBtn {
      min-width: 90px;
      border: none;
      background-color: transparent;
      text-align: center;
      align-self: center;
      outline: none;
      svg {
        position: relative;
        top: 2px;
      }
      span {
        font-size: 15px;
        font-family: var(--sf-pro-display-m);
        color: #605e5c;
        padding-left: 7px;
      }
    }
  }
  .exportDataBtn {
    align-self: center;
    button {
      &:last-child {
        margin-right: 0px;
      }
      svg {
        top: 3px;
      }
    }
  }
`;

const RadioGoupStyle = styled.div`
.switchRadio .ant-radio-group-solid label {
  min-height: 38px !important;
    width: auto !important;
    height:auto !important;
    line-height: 27px !important;
    display:flex;
}
.switchRadio .ant-radio-group-solid label span:last-child {
  color: #a19f9d !important;
 
}
.ant-radio-button-wrapper:last-child {
  border-radius: 0px 8px 8px 0px !important;
}
.ant-radio-button-wrapper:first-child {
  border-radius: 8px 0px 0px 8px !important;
}
.ant-radio-group.ant-radio-group-solid.jcActive label:nth-child(2) span {
  color: var(--theme-color) !important;
  font-family: var(--sf-pro-display) !important;
}
.ant-radio-group.ant-radio-group-solid.sheetActive label:last-child span {
  color: var(--theme-color) !important;
  font-family: var(--sf-pro-display) !important;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover::before  {
  background-color : #a19f9d;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
  background-color: #a19f9d;
}
`;

const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

const SearchContainer = ({
  placeholder,
  fetchOrder,
  exportRole,
  exportTrigger,
  clearSearch,
  setClearSearch,
  filterOptions,
  applyFilter,
  hideSearch,
  closeMappingRole,
  closeMapping,
  isUpdateOrderDetailsInBulkVisible,
  isUpdateOrderDetailsButtonEnable,
  updateButtonClick,
  isShowCancelButton,
  cancelButtonClick,
  isShowReviewAndUpdateButton,
  reviewAndUpdateClick,
  searchedValue,
  productRecordRole,
  addNewSizeClick,
  jumboStatus,
  isOtherFilter,
  ismachineOrderSearch,
  isPendingTab,
  onShowOrders,
  isAllOrder,
  showBulkOrderUpdate,
  selectedOrderType,
  deckleOrderType,
  isDisableSave,
  setOrderType,
  setDeckleOrderType,
  jumboReelSearch,
  unitType,
  isAddRewinderDimension,
  isMoveToSelection,
  onAddRewinderDimension,
  onMoveToSelection,
  isAddRewinderDetailsPressed,
  selectedRowKeys,
  isSelectedOrder,
  selectedReelType,
  onReelTypeChange,
  hideExport,
  showModifiedDateFilter=false,
  modifiedFilterLabel,
  setModifiedFilterLabel,
  isDisabled=false,
  storeModifiedFilterLabel, setStoreModifiedFilterLabel,
  orderTypesProp = null,
  unitDataProp = null,
}) => {
  const [isDatePickerVisible,setDatePickerVisible] = useState(false);
  const filterModalRef = useRef();
  const customRanges = [
    {
      label:"All",
      range:()=>({
        startDate:null,
        endDate:moment().add(1,"day").toDate()
      })
    },
    {
      label:"Today",
      range:()=>({
        startDate:moment().startOf("day").toDate(),
        endDate:moment().endOf("day").toDate()
      })
    },
    {
      label:"Yesterday",
      range:()=>({
        startDate:moment().subtract(1,"days").startOf("day").toDate(),
        endDate:moment().subtract(1,"days").endOf("day").toDate()
      })
    },
    {
      label:"This Month",
      range:()=>({
        startDate:moment().startOf('month').toDate(),
        endDate:moment().add(1,"day").endOf("day").toDate()
      })
    },
    {
      label:"Last Month",
      range:()=>({
        startDate:moment().subtract(1,"month").startOf('month').toDate(),
        endDate:moment().subtract(1,"month").endOf('month').toDate()
      })
    },
    {
      label:"Last 7 days",
      range:()=>({
        startDate:moment().subtract(7,"days").toDate(),
        endDate:moment().add(1,"day").toDate()
      })
    },
    {
      label:"Last 15 days",
      range:()=>({
        startDate:moment().subtract(15,"days").toDate(),
        endDate:moment().add(1,"day").toDate()
      })
    },
    {
      label:"Last 30 days",
      range:()=>({
        startDate:moment().subtract(30,"days").toDate(),
        endDate:moment().add(1,"day").toDate()
      })
    }
  ]
  const selectedGsmOptions = useRef('equal_to');
  const [filterType, setFilterType] = useState();
  const [showFilterOptions, setShowFilterOptions] = useState(false);
  const [gsmFilterType, setGsmFilterType] = useState('equal_to');
  const [checkAllStates, setCheckAllStates] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);
  const [selectedStates, setSelectedStates] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [dateSelectionRange, setDateSelectionRange] = useState({
    startDate: new Date(),
    endDate: null,
    key: "selection",
  });
  const [dateRangeForModifiedFilter, setDateRangeForModifiedFilter] = useState({
    startDate: new Date(),
    endDate: null,
    key: "selection",
  });
  const [form] = Form.useForm();
  const [filterForm] = Form.useForm();
  const [sizeFilterForm] = Form.useForm();
  const [jobCardForm] = Form.useForm();
  const [appliedFiltersArray, setAppliedFiltersArray] = useState();
  const [countries, setCountries] = useState([]);
  const [machines, setMachines] = useState([]);
  const [filterBtnDisable, setFilterBtnDisable] = useState(false);
  const [grades, setGrades] = useState([]);
  const [searchedGrades, setSearchedGrades] = useState([]);
  const [qualities, setQualities] = useState([]);
  const [searchedQualities, setSearchedQualties] = useState([]);
  const [showQualities, setShowQualities] = useState(false);
  const [selectedGrade, setSelectedGrade] = useState();
  const [selectedQualities, setSelectedQualities] = useState();
  const [checkAllQualities, setCheckAllQualities] = useState(false);
  const [qualityIndeterminate, setQualityIndeterminate] = useState(false);
  const [selectedGradeQualities, setSelectedGradeQualtites] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [products, setProducts] = useState([]);
  const [unitData,setUnitData] = useState(unitDataProp);
  const [multiSelectSearch, setMultiSelectSearch] = useState({
    bool: false,
    searchedOptions: [],
  });
  const [disableFilter, setDisableFilter] = useState(true);
  const [rewinders, setRewinders] = useState([]);
  const [cutters, setCutters] = useState([]);
  const [machinesList, setMchinesList] = useState([]);
  const [machineFilterType, setMachineFilterType] = useState();
  const [orderTypesData, setOrderTypesData] = useState(orderTypesProp);
  const [hasSetInitialValue, setHasSetInitialValue] = useState(false);
  
  const gsmFilterOptions = [
    { label: "Equal to", value: "equal_to" },
    { label: "Less than", value: "less_than" },
    { label: "Greater than", value: "greater_than" },
    { label: "In Range", value: "in_range" },
  ];

  const machineFilterOptions = [
    { label: "Machine", value: "paper_machine" },
    { label: "Rewinder", value: "rewinder" },
    { label: "Cutter", value: "cutter" },
  ];

  const equalFilterOption = [{ label: "Equal to", value: "equal_to" }];

  const sizeTypeOptions = [
    { label: "Width", value: "width" },
    { label: "Length", value: "length" },
    { label: "Both", value: "both" },
  ];

  const statusOptions = [
    { value: "Active", label: "Active" },
    { value: "Disabled", label: "Disabled" },
  ];

  const categoryOptions = [
    { value: "Domestic", label: "Domestic" },
    { value: "Export", label: "Export" },
  ];

  //generic enum to set options for different multiselects
  const multiSelectEnum = {
    status: { options: statusOptions },
    category : {options : categoryOptions},
    country: { options: countries },
    shift: {
      options: [
        { value: "1st", label: "1st" },
        { value: "2nd", label: "2nd" },
        { value: "3rd", label: "3rd" },
      ],
    },
    statusOpen: {
      options: [
        { value: "open", label: "open" },
        { value: "closed", label: "closed" },
      ],
    },
    orderStatus: {
      options: [
        { value: "Open", label: "Open" },
        { value: "Pending", label: "Pending" },
        { value: "Changes Requested", label: "Changes Requested" },
        { value: "Approved", label: "Approved" },
        { value: "Rejected", label: "Rejected" },
        { value: "On Hold", label: "On Hold" },
      ],
    },
    machine: { options: machines },
    order_type: {
      options: [
        { value: "Reel", label: "Reel" },
        { value: "Sheet", label: "Sheet" },
      ],
    },
    ply_type: {
      options: [
        { label: "Single Ply", value: 1 },
        { label: "Double Ply", value: 2 },
        { label: "3-Ply", value: 3 },
        { label: "4-Ply", value: 4 },
      ],
    },
    deckle_order_type: {
      options: [
        { value: "Unplanned Orders", label: "Unplanned Orders" },
        { value: "Planned Orders", label: "Planned Orders" },
      ],
    },
    cutter_type: {
      options: [
        { value: "Simplex", label: "Simplex" },
        { value: "Duplex", label: "Duplex" },
      ],
    },
    customer: { options: customers },
    consignee: { options: customers },
    product: { options: products },
    priority: {
      options: [
        { value: "Yes", label: "Yes" },
        { value: "No", label: "No" },
      ],
    },
    productionStatus: {
      options: [
        { value: "Open", label: "Open" },
        { value: "Produced", label: "Produced" },
        { value: "Rejected", label: "Rejected" },
        { value: "Cancelled", label: "Cancelled" },
      ],
    },
    role: {
      options: [
        { value: "Basic", label: "Basic" },
        { value: "Admin", label: "Admin" },
      ],
    },
    machine_type: {
      options: [
        { value: "Rewinding", label: "Rewinding" },
        { value: "Cutting", label: "Cutting" },
      ],
    },
    item_type: {
      options: [
        { value: "order", label: "Order" },
        { value: "stock", label: "Stock" },
      ],
    },
  };
  const filterRef = useRef();

  const filterViewData = [
    {
      label: (
        
          <span
            style={{
              transform: "translateY(-5px)",
              color: "#ea655b",
              fontFamily: "var(--sf-pro-display) !important"
            }}
          >
            All Items
          </span>
        
      ),
      value: "both",
    },
    {
      label: (
        
          <span
            style={{
              transform: "translateY(-5px)",
              color: "#ea655b",
              fontFamily: "var(--sf-pro-display) !important"
            }}
          >
            Finished Items
          </span>
        
      ),
      value: "finished",
    },
    {
      label: (
        
          <span
            style={{
              transform: "translateY(-5px)",
              color: "#ea655b",
              fontFamily: "var(--sf-pro-display) !important"
            }}
          >
            Intermediate Items
          </span>
        
      ),
      value: "intermediate",
    },
  ];

  const handleClickOutside = (e) => {
    if(filterModalRef.current && !filterModalRef?.current?.contains(e.target) &&
       !e.target.innerText?.includes("Modified"))
    {
      setDatePickerVisible(false);
    }
    if (
      e.target.innerText !== "Equal to" &&
      e.target.innerText !== "Less than" &&
      e.target.innerText !== "Greater than" &&
      e.target.innerText !== "In Range" &&
      e.target.innerText !== "Width" &&
      e.target.innerText !== "Length" &&
      e.target.innerText !== "Both" &&
      e.target.innerText !== "Machine" &&
      e.target.innerText !== "Rewinder" &&
      e.target.innerText !== "Cutter" &&
      !(unitData?.units_management?.length.data.filter(( name ) => name === e.target.innerText || lengthUnit[name]?.displayName === e.target.innerText).length) &&
      !(unitData?.units_management?.weight.data.filter(( name ) => name === e.target.innerText || weightUnit[name]?.displayName === e.target.innerText).length) &&
      !(unitData?.units_management?.currency.data.filter(( name ) => name === e.target.innerText).length) &&
      !filterRef?.current?.contains(e.target)
    ) {
      setShowFilterOptions(false);
      filterForm.resetFields();
      sizeFilterForm.resetFields();
      jobCardForm.resetFields();
      setGsmFilterType('equal_to');
      selectedGsmOptions.current = 'equal_to';
      setFilterType();
      setFilterBtnDisable(false);
    }
  };


  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  });

  const selectAllHandler = (e) => {
    setCheckAllStates(!checkAllStates);
    setSelectedStates(
      e.target.checked ? multiSelectEnum[filterType.value].options : []
    );
    setIndeterminate(false);
  };

  const checkBoxOptionHandler = (e) => {
    setSelectedOption(e);
    let updatedSelectedOption = [];
    for (let index = 0; index < e.length; index++) {
      const element = e[index];
      updatedSelectedOption.push(element.value);
    }
    setSelectedStates(updatedSelectedOption);
    setCheckAllStates(
      e.length === multiSelectEnum[filterType.value].options.length
    );
    setIndeterminate(
      e.length && e.length < multiSelectEnum[filterType.value].options.length
    );
  };

  const machineCheckBoxOptionHandler = (e) => {
    setSelectedOption(e);
    let updatedSelectedOption = [];
    for (let index = 0; index < e.length; index++) {
      const element = e[index];
      updatedSelectedOption.push(element.value);
    }
    setSelectedStates(updatedSelectedOption);
    if(machineFilterType == 'paper_machine')
    {
      setCheckAllStates(
        e.length === machines.length
      );
      setIndeterminate(
        e.length && e.length < machines.length
      );
    }
    
    else if(machineFilterType == 'rewinder')
    {
      setCheckAllStates(
        e.length === rewinders.length
      );
      setIndeterminate(
        e.length && e.length < rewinders.length
      );
    }
    else
    {
      setCheckAllStates(
        e.length === cutters.length
      );
      setIndeterminate(
        e.length && e.length < cutters.length
      );
    }
   
  };

  const selectAllQualitiesHandler = (e) => {
    setCheckAllQualities(!checkAllQualities);
    // setSelectedQualities(e.target.checked ? qualities : []);
    setQualityIndeterminate(false);
    if (e.target.checked)
    {
      setDisableFilter(false);
      setSelectedQualities(qualities);
    }
    else {
      if (selectedQualities?.length)
        setDisableFilter(false);
      else
        setDisableFilter(true);
        setSelectedQualities([]);
    }
    
  };

  const checkQualityHandler = (e) => {
    setSelectedQualities(e);
    setCheckAllStates(e.length === qualities.length);
    setCheckAllQualities(e.length === qualities.length);
    setIndeterminate(e.length && e.length < qualities.length);
  };

  const filterSelect = (e) => {
    setFilterType(filterOptions[e.key]);
    setFilterBtnDisable(true);
    if (filterOptions[e.key]?.value !== "grade_quality") {
      closeFilterDropDown();
    } else {
      //setShowQualities(true)
    }
  };

  const showFilterDropDown = () => {
    setShowFilterOptions(!showFilterOptions);
  };

  const backFilter = () => {
    setFilterType();
    setShowFilterOptions(true);
    setFilterBtnDisable(false);
    setDisableFilter(true);
    setSelectedStates([]);
    setSelectedOption([]);
  };

  const applyFilterHandler = () => {
    sizeFilterForm.validateFields().then(() => {
    setFilterBtnDisable(false);
    setDisableFilter(true);
    if (
      filterType.type === "inputSelect" ||
      filterType.type === "equalInputSelect"
    ) {
      let minValue = parseFloat(filterForm.getFieldValue("gsmMin"));
      let maxValue = parseFloat(filterForm.getFieldValue("gsmMax"));
      let thresholdValue = parseFloat(
        filterForm.getFieldValue("gsmFilterValue")
      );

      switch (filterType.value) {
        
          
        
        case "gsm":
          const gsmFilter = {
            type: filterType.value,
            operator:selectedGsmOptions.current,
//operator: gsmFilterType,
            ...(selectedGsmOptions.current === "in_range" && { min_gsm: minValue }),
            ...(selectedGsmOptions.current === "in_range" && { max_gsm: maxValue }),
            ...(selectedGsmOptions.current !== "in_range" && { gsm: thresholdValue }),
          };
          applyFilter(gsmFilter);
          setAppliedFiltersArray(gsmFilter);
          break;
        case "min_gsm":
          const minGsmFilter = {
            type: filterType.value,
            operator:selectedGsmOptions.current,
//operator: gsmFilterType,
            ...(selectedGsmOptions.current === "in_range" && { min_gsm_range: minValue }),
            ...(selectedGsmOptions.current === "in_range" && { max_gsm_range: maxValue }),
            ...(selectedGsmOptions.current !== "in_range" && { min_gsm: thresholdValue }),
            ...(filterType.unitType && selectedGsmOptions.current === "in_range" && { units : {min_gsm_range : filterForm.getFieldValue("unitSelect"),
            max_gsm_range : filterForm.getFieldValue("unitSelect")} }),
            ...(filterType.unitType && selectedGsmOptions.current !== "in_range" && { units : {min_gsm : filterForm.getFieldValue("unitSelect")} }),

          };
          applyFilter(minGsmFilter);
          setAppliedFiltersArray(minGsmFilter);
          break;
        case "max_gsm":
          const maxGsmFilter = {
            type: filterType.value,
            operator:selectedGsmOptions.current,
//operator: gsmFilterType,
            ...(selectedGsmOptions.current === "in_range" && { max_gsm_start: minValue }),
            ...(selectedGsmOptions.current === "in_range" && { max_gsm_end: maxValue }),
            ...(selectedGsmOptions.current !== "in_range" && { max_gsm: thresholdValue }),
            ...(filterType.unitType && selectedGsmOptions.current === "in_range" && { units : {max_gsm_start : filterForm.getFieldValue("unitSelect"),
            max_gsm_end : filterForm.getFieldValue("unitSelect")} }),
            ...(filterType.unitType && selectedGsmOptions.current !== "in_range" && { units : {max_gsm : filterForm.getFieldValue("unitSelect")} }),
          };
          applyFilter(maxGsmFilter);
          setAppliedFiltersArray(maxGsmFilter);
          break;
        case "burst_factor":
          const bfFilter = {
            type: filterType.value,
            operator:selectedGsmOptions.current,
//operator: gsmFilterType,
            ...(selectedGsmOptions.current === "in_range" && { min_burst_factor: minValue }),
            ...(selectedGsmOptions.current === "in_range" && { max_burst_factor: maxValue }),
            ...(selectedGsmOptions.current !== "in_range" && {
              burst_factor: thresholdValue,
            }),
          };
          applyFilter(bfFilter);
          setAppliedFiltersArray(bfFilter);
          break;
        case "width":
          const widthFilter = {
            type: filterType.value,
            operator:selectedGsmOptions.current,
//operator: gsmFilterType,
            ...(selectedGsmOptions.current === "in_range" && { min_width: minValue }),
            ...(selectedGsmOptions.current === "in_range" && { max_width: maxValue }),
            ...(selectedGsmOptions.current !== "in_range" && { width: thresholdValue }),
            ...(filterType.unitType && selectedGsmOptions.current === "in_range" && { units : {min_width : filterForm.getFieldValue("unitSelect"),
            max_width : filterForm.getFieldValue("unitSelect")} }),
            ...(filterType.unitType && selectedGsmOptions.current !== "in_range" && { units : {width : filterForm.getFieldValue("unitSelect")} }),
          };
          applyFilter(widthFilter);
          setAppliedFiltersArray(widthFilter);
          break;
        case "utilization":
          const utilizationFilter = {
            type: filterType.value,
            operator:selectedGsmOptions.current,
//operator: gsmFilterType,
            ...(selectedGsmOptions.current === "in_range" && { min_utilization: minValue }),
            ...(selectedGsmOptions.current === "in_range" && { max_utilization: maxValue }),
            ...(selectedGsmOptions.current !== "in_range" && {
              utilization: thresholdValue }),
              ...(filterType.unitType && selectedGsmOptions.current === "in_range" && { units : {min_utilization : filterForm.getFieldValue("unitSelect"),
              max_utilization : filterForm.getFieldValue("unitSelect")} }),
              ...(filterType.unitType && selectedGsmOptions.current !== "in_range" && { units : {utilization : filterForm.getFieldValue("unitSelect")} }),
           
          };
          applyFilter(utilizationFilter);
          setAppliedFiltersArray(utilizationFilter);
          break;
        case "min_deckle_width":
          const minDeckleWidthFilter = {
            type: filterType.value,
            operator:selectedGsmOptions.current,
//operator: gsmFilterType,
            ...(selectedGsmOptions.current === "in_range" && { min_deckle_width: minValue }),
            ...(selectedGsmOptions.current === "in_range" && { max_deckle_width: maxValue }),
            ...(selectedGsmOptions.current !== "in_range" && {
              deckle_width: thresholdValue }),
              ...(filterType.unitType && selectedGsmOptions.current === "in_range" && { units : {min_deckle_width : filterForm.getFieldValue("unitSelect"),
              max_deckle_width : filterForm.getFieldValue("unitSelect")} }),
              ...(filterType.unitType && selectedGsmOptions.current !== "in_range" && { units : {deckle_width : filterForm.getFieldValue("unitSelect")} }),
           
          };
          applyFilter(minDeckleWidthFilter);
          setAppliedFiltersArray(minDeckleWidthFilter);
          break;
        case "max_deckle_width":
          const maxDeckleWidthFilter = {
            type: filterType.value,
            operator:selectedGsmOptions.current,
//operator: gsmFilterType,
            ...(selectedGsmOptions.current === "in_range" && { min_deckle_width: minValue }),
            ...(selectedGsmOptions.current === "in_range" && { max_deckle_width: maxValue }),
            ...(selectedGsmOptions.current !== "in_range" && {
              deckle_width: thresholdValue }),
              ...(filterType.unitType && selectedGsmOptions.current === "in_range" && { units : {min_deckle_width : filterForm.getFieldValue("unitSelect"),
              max_deckle_width : filterForm.getFieldValue("unitSelect")} }),
              ...(filterType.unitType && selectedGsmOptions.current !== "in_range" && { units : {deckle_width : filterForm.getFieldValue("unitSelect")} }),
           
          };
          applyFilter(maxDeckleWidthFilter);
          setAppliedFiltersArray(maxDeckleWidthFilter);
          break;
        case "production_capacity":
          const prodCapacityFilter = {
            type: filterType.value,
            operator:selectedGsmOptions.current,
//operator: gsmFilterType,
            ...(selectedGsmOptions.current === "in_range" && {
              min_production_capacity: minValue,
            }),
            ...(selectedGsmOptions.current === "in_range" && {
              max_production_capacity: maxValue,
            }),
            ...(selectedGsmOptions.current !== "in_range" && {
              production_capacity: thresholdValue,
            }),
            ...(filterType.unitType && selectedGsmOptions.current === "in_range" && { units : {min_production_capacity : filterForm.getFieldValue("unitSelect"),
            max_production_capacity : filterForm.getFieldValue("unitSelect")} }),
            ...(filterType.unitType && selectedGsmOptions.current !== "in_range" && { units : {production_capacity : filterForm.getFieldValue("unitSelect")} }),
          };
          applyFilter(prodCapacityFilter);
          setAppliedFiltersArray(prodCapacityFilter);
          break;
        case "maximum_waste":
          const maxWasteFilter = {
            type: filterType.value,
            operator:selectedGsmOptions.current,
//operator: gsmFilterType,
            ...(selectedGsmOptions.current === "in_range" && {
              min_maximum_waste: minValue,
            }),
            ...(selectedGsmOptions.current === "in_range" && {
              max_maximum_waste: maxValue,
            }),
            ...(selectedGsmOptions.current !== "in_range" && {
              maximum_waste: thresholdValue,
            }),
          };
          applyFilter(maxWasteFilter);
          setAppliedFiltersArray(maxWasteFilter);
          break;
          case "maximum_loss":
          const maxLossFilter = {
            type: filterType.value,
            operator:selectedGsmOptions.current,
//operator: gsmFilterType,
            ...(selectedGsmOptions.current === "in_range" && {
              min_maximum_loss: minValue,
            }),
            ...(selectedGsmOptions.current === "in_range" && {
              max_maximum_loss: maxValue,
            }),
            ...(selectedGsmOptions.current !== "in_range" && {
              maximum_loss: thresholdValue,
            }),
          };
          applyFilter(maxLossFilter);
          setAppliedFiltersArray(maxLossFilter);
          break;
        case "bulk":
          const bulkFilter = {
            type: filterType.value,
            operator:selectedGsmOptions.current,
//operator: gsmFilterType,
            ...(selectedGsmOptions.current === "in_range" && { min_bulk: minValue }),
            ...(selectedGsmOptions.current === "in_range" && { max_bulk: maxValue }),
            ...(selectedGsmOptions.current !== "in_range" && { bulk: thresholdValue }),
          };
          applyFilter(bulkFilter);
          setAppliedFiltersArray(bulkFilter);
          break;
        case "price":
          const priceFilter = {
            type: filterType.value,
            operator:selectedGsmOptions.current,
//operator: gsmFilterType,
            ...(selectedGsmOptions.current === "in_range" && { min_price: minValue }),
            ...(selectedGsmOptions.current === "in_range" && { max_price: maxValue }),
            ...(selectedGsmOptions.current !== "in_range" && { price: thresholdValue }),
            ...(filterType.unitType && selectedGsmOptions.current === "in_range" && { units : {min_price : filterForm.getFieldValue("unitSelect"),
            max_price : filterForm.getFieldValue("unitSelect")} }),
              ...(filterType.unitType && selectedGsmOptions.current !== "in_range" && { units : {price : filterForm.getFieldValue("unitSelect")} }),
          };
          applyFilter(priceFilter);
          setAppliedFiltersArray(priceFilter);
          break;
        case "reel_od":
          const reel_odFilter = {
            type: filterType.value,
            operator:selectedGsmOptions.current,
//operator: gsmFilterType,
            ...(selectedGsmOptions.current === "in_range" && { min_reel_od: minValue }),
            ...(selectedGsmOptions.current === "in_range" && { max_reel_od: maxValue }),
            ...(selectedGsmOptions.current !== "in_range" && { reel_od: thresholdValue }),
            ...(filterType.unitType && selectedGsmOptions.current === "in_range" && { units : {min_reel_od : filterForm.getFieldValue("unitSelect"),
            max_reel_od : filterForm.getFieldValue("unitSelect")} }),
              ...(filterType.unitType && selectedGsmOptions.current !== "in_range" && { units : {reel_od : filterForm.getFieldValue("unitSelect")} }),
          };
          applyFilter(reel_odFilter);
          setAppliedFiltersArray(reel_odFilter);
          break;
        case "jcNo":
          const jcNoFilter = {
            type: filterType.value,
            operator:selectedGsmOptions.current,
//operator: gsmFilterType,
            ...(selectedGsmOptions.current === "in_range" && { min_reel_od: minValue }),
            ...(selectedGsmOptions.current === "in_range" && { max_reel_od: maxValue }),
            ...(selectedGsmOptions.current !== "in_range" && { jcNo: thresholdValue }),
          };
          applyFilter(jcNoFilter);
          setAppliedFiltersArray(jcNoFilter);
          break;
        case "core_id":
          const core_idFilter = {
            type: filterType.value,
            operator:selectedGsmOptions.current,
//operator: gsmFilterType,
            ...(selectedGsmOptions.current === "in_range" && { min_core_id: minValue }),
            ...(selectedGsmOptions.current === "in_range" && { max_core_id: maxValue }),
            ...(selectedGsmOptions.current !== "in_range" && { core_id: thresholdValue }),
            ...(filterType.unitType && selectedGsmOptions.current === "in_range" && { units : {min_core_id : filterForm.getFieldValue("unitSelect"),
            max_core_id : filterForm.getFieldValue("unitSelect")} }),
            ...(filterType.unitType && selectedGsmOptions.current !== "in_range" && { units : {core_id : filterForm.getFieldValue("unitSelect")} }),
          };
          applyFilter(core_idFilter);
          setAppliedFiltersArray(core_idFilter);
          break;

          case "capacity":
            const capacityFilter = {
              type: filterType.value,
              operator:selectedGsmOptions.current,
//operator: gsmFilterType,
              ...(selectedGsmOptions.current === "in_range" && { min_capacity: minValue }),
              ...(selectedGsmOptions.current === "in_range" && { max_capacity: maxValue }),
              ...(selectedGsmOptions.current !== "in_range" && { capacity: thresholdValue }),
              ...(filterType.unitType && selectedGsmOptions.current === "in_range" && { units : {min_capacity : filterForm.getFieldValue("unitSelect"),
              max_capacity : filterForm.getFieldValue("unitSelect")} }),
              ...(filterType.unitType && selectedGsmOptions.current !== "in_range" && { units : {capacity : filterForm.getFieldValue("unitSelect")} }),
  
            };
            applyFilter(capacityFilter);
            setAppliedFiltersArray(capacityFilter);
            break;
            case "loading_stands":
              const loadingStandsFilter = {
                type: filterType.value,
                operator:selectedGsmOptions.current,
//operator: gsmFilterType,
                ...(selectedGsmOptions.current === "in_range" && {
                  min_loading_stands: minValue,
                }),
                ...(selectedGsmOptions.current === "in_range" && {
                  max_loading_stands: maxValue,
                }),
                ...(selectedGsmOptions.current !== "in_range" && {
                  loading_stands: thresholdValue,
                }),
              };
              applyFilter(loadingStandsFilter);
              setAppliedFiltersArray(loadingStandsFilter);
              break;
              case "minimum_reel_dia":
                const minReelfitlter = {
                  type: filterType.value,
                  operator:selectedGsmOptions.current,
//operator: gsmFilterType,
                  ...(selectedGsmOptions.current === "in_range" && { minimum_reel_dia: minValue }),
                  ...(selectedGsmOptions.current === "in_range" && { maximum_reel_dia: maxValue }),
                  ...(selectedGsmOptions.current !== "in_range" && { minimum_reel_dia: thresholdValue }),
                  ...(filterType.unitType && selectedGsmOptions.current === "in_range" && { units : {minimum_reel_dia : filterForm.getFieldValue("unitSelect"),
                  maximum_reel_dia : filterForm.getFieldValue("unitSelect")} }),
                  ...(filterType.unitType && selectedGsmOptions.current !== "in_range" && { units : {minimum_reel_dia : filterForm.getFieldValue("unitSelect")} }),
      
                };
                applyFilter(minReelfitlter);
                setAppliedFiltersArray(minReelfitlter);
                break;
                case "maximum_reel_dia":
                  const maxReelfitlter = {
                    type: filterType.value,
                    operator:selectedGsmOptions.current,
//operator: gsmFilterType,
                    ...(selectedGsmOptions.current === "in_range" && { minimum_reel_dia: minValue }),
                    ...(selectedGsmOptions.current === "in_range" && { maximum_reel_dia: maxValue }),
                    ...(selectedGsmOptions.current !== "in_range" && { maximum_reel_dia: thresholdValue }),
                    ...(filterType.unitType && selectedGsmOptions.current === "in_range" && { units : {minimum_reel_dia : filterForm.getFieldValue("unitSelect"),
                    maximum_reel_dia : filterForm.getFieldValue("unitSelect")} }),
                    ...(filterType.unitType && selectedGsmOptions.current !== "in_range" && { units : {maximum_reel_dia : filterForm.getFieldValue("unitSelect")} }),
        
                  };
                  applyFilter(maxReelfitlter);
                  setAppliedFiltersArray(maxReelfitlter);
                  break;
               
           
      }
      closeFilterDetails();
      setShowFilterOptions(false);
      filterForm.resetFields();
      sizeFilterForm.resetFields();
      jobCardForm.resetFields();
    } else if (filterType.type === "rangeTypeSelect") {
      let minValue = parseFloat(sizeFilterForm.getFieldValue("gsmMin"));
      let maxValue = parseFloat(sizeFilterForm.getFieldValue("gsmMax"));
      let thresholdValue = parseFloat(
        sizeFilterForm.getFieldValue("gsmFilterValue")
      );
      let sizeType;
      if(orderTypesData?.length == 1 && orderTypesData[0]?.name == "reel"){
        sizeType = "width";
      } else{
        sizeType = sizeFilterForm.getFieldValue("sizeType");
      }
      // const sizeFilter = {
      //   type: filterType.value,
      //   operator:selectedGsmOptions.current,
//operator: gsmFilterType,
      //   size_type: sizeType,
      //   ...(selectedGsmOptions.current === "in_range" && { min_size: minValue }),
      //   ...(selectedGsmOptions.current === "in_range" && { max_size: maxValue }),
      //   ...(selectedGsmOptions.current !== "in_range" && { size: thresholdValue }),
      //   ...(filterType.unitType && selectedGsmOptions.current === "in_range" && { units : {min_size : sizeFilterForm.getFieldValue("unitSelect"),
      //   max_size : sizeFilterForm.getFieldValue("unitSelect")} }),
      //       ...(filterType.unitType && selectedGsmOptions.current !== "in_range" && { units : {size : sizeFilterForm.getFieldValue("unitSelect")} }),
      // };
      const sizeFilter = {
            type: filterType.value,
            operator: (orderTypesData?.length == 1 && orderTypesData[0]?.name == "reel") ? gsmFilterOptions[0]?.value : gsmFilterType,
            size_type: sizeType,
            ...(selectedGsmOptions.current === "in_range" && { min_size: minValue }),
            ...(selectedGsmOptions.current === "in_range" && { max_size: maxValue }),
            ...(((orderTypesData?.length == 1 && orderTypesData[0]?.name == "reel") || selectedGsmOptions.current !== "in_range") && { size: thresholdValue }),
            ...(filterType.unitType && selectedGsmOptions.current === "in_range" && { units : {min_size : sizeFilterForm.getFieldValue("unitSelect"),
              max_size : sizeFilterForm.getFieldValue("unitSelect")} }),
            ...(filterType.unitType && ((orderTypesData?.length == 1 && orderTypesData[0]?.name == "reel") || selectedGsmOptions.current !== "in_range") && { units : {size : sizeFilterForm.getFieldValue("unitSelect")} }),
          };
      applyFilter(sizeFilter);
      setAppliedFiltersArray(sizeFilter);
      closeFilterDetails();
      setShowFilterOptions(false);
      filterForm.resetFields();
      sizeFilterForm.resetFields();
      jobCardForm.resetFields();
    } else if (filterType.type === "input") {
      let thresholdValue = parseInt(
        jobCardForm.getFieldValue("gsmFilterValue")
      );
      const jobCardFilter = {
        type: filterType.value,
        jobcard: thresholdValue,
      };
      applyFilter(jobCardFilter);
      setAppliedFiltersArray(jobCardFilter);
      closeFilterDetails();
      setShowFilterOptions(false);
      filterForm.resetFields();
      sizeFilterForm.resetFields();
      jobCardForm.resetFields();
    } else if (filterType.type === "machineType")
    {
      const machineDataFilter = {
        type: 'machine',
        machine_type : machineFilterType,
        machine_code : selectedOption.map((machine) => { return machine.value})

      };
      applyFilter(machineDataFilter);
      setAppliedFiltersArray(machineDataFilter);
      closeFilterDetails();
      setShowFilterOptions(false);
      filterForm.resetFields();
      sizeFilterForm.resetFields();
      jobCardForm.resetFields();
      setSelectedGrade();
        setFilterBtnDisable(false);
        setDisableFilter(true);
        closeFilterDetails();
        setShowFilterOptions(false);
        setSelectedGradeQualtites([]);
        setCheckAllQualities(false);
        setSelectedQualities([]);
        setIndeterminate(false);
    } 
    else {
      if (appliedFiltersArray) {
        setSelectedGrade();
        setFilterBtnDisable(false);
        setDisableFilter(true);
        applyFilter(appliedFiltersArray);
        closeFilterDetails();
        setShowFilterOptions(false);
        setSelectedGradeQualtites([]);
        setCheckAllQualities(false);
        setSelectedQualities([]);
        setIndeterminate(false);
        setSearchedGrades(grades);
        setSearchedQualties(qualities);
        setShowQualities(false);
      }
    }
    setSelectedStates([]);
    setSelectedOption([]);
  }).catch((err) => {
    setDisableFilter(true);
  })
  };

  const clearHandler = () => {
    setFilterBtnDisable(false);
    closeFilterDetails();
    setShowFilterOptions(false);
    setDisableFilter(true);
    setQualities([]);
    setShowQualities(false);
    setSelectedGrade();
    setSelectedQualities([]);
    clearFilters();
    setAppliedFiltersArray();
    filterForm.resetFields();
    sizeFilterForm.resetFields();
    setSelectedGradeQualtites([]);
    setCheckAllQualities(false);
    setSelectedQualities([]);
    jobCardForm.resetFields();
    setIndeterminate(false);
  };

  const closeFilterDropDown = () => {
    setShowFilterOptions(false);
  };

  const closeFilterDetails = () => {
    filterForm.resetFields();
    sizeFilterForm.resetFields();
    jobCardForm.resetFields();
    setGsmFilterType();
    selectedGsmOptions.current = 'equal_to';
    setFilterType();
  };

  // const selectionRange = {
  //   startDate: new Date(),
  //   endDate: new Date(),
  //   key: "selection",
  // };

  const handleDateSelect = (ranges) => {
    console.log("Filter type in filter", filterType, ranges);
    setDateSelectionRange({
      startDate: ranges.selection.startDate,
      endDate: ranges.selection.endDate,
      key: "selection",
    });
    const newFilter = {
      type: filterType.value,
      start_date: moment(ranges.selection.startDate).format("YYYY-MM-DD"),
      end_date: moment(ranges.selection.endDate).format("YYYY-MM-DD"),
    };
    if (dateSelectionRange.startDate && dateSelectionRange.endDate) {
      setDisableFilter(false);
    } else setDisableFilter(true);
    setAppliedFiltersArray(newFilter);
  };
  function applyModifiedDateFilterHandler(){
    let label="";
    customRanges.forEach((item)=>{
      if(moment(item.range().startDate)?.format("YYYY-MM-DD HH:mm") == moment(dateRangeForModifiedFilter.startDate)?.format("YYYY-MM-DD HH:mm") && moment(item.range().endDate)?.format("YYYY-MM-DD HH:mm") == moment(dateRangeForModifiedFilter.endDate)?.format("YYYY-MM-DD HH:mm"))
      {
        label=item.label;
      }
    })
    if(label == "")
    {
      label= moment(dateRangeForModifiedFilter.startDate)?.format("DD MMM")+" - "+moment(dateRangeForModifiedFilter.endDate)?.format("DD MMM"); 
    }
    const modifiedDateFilter = {
      type:"updated_date",
      start_date:moment(dateRangeForModifiedFilter.startDate).format("YYYY-MM-DD"),
      end_date:moment(dateRangeForModifiedFilter.endDate).format("YYYY-MM-DD"),
    }
    applyFilter(modifiedDateFilter);
    setModifiedFilterLabel(label);
    setStoreModifiedFilterLabel(label);
    setDatePickerVisible(false);
  }

  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        func?.apply(context, args);
      }, wait);
    };
  }

  useEffect(() => {
    if (clearSearch) {
      form.setFieldsValue({
        username: "",
      });
    }
  }, [clearSearch]);

  const debounceOnChange = React.useCallback(debounce(fetchOrder, 1000), []);

  useEffect(() => {
    if (clearSearch) {
      form.resetFields();
      sizeFilterForm.resetFields();
      jobCardForm.resetFields();
      setClearSearch(false);
    }
  }, [clearSearch]);

  //countries fetch
  useEffect(() => {
    ( async() => {
    getCountries().then((resp) => {
      // console.log("Countries", resp);
      setCountries(
        resp.data.data.map((item) => {
          return { value: item, label: item };
        })
      );
    });
    !unitDataProp && await getUnitData().then((response) => {
      let data = response.data;
      let filteredCurrency = currency_List.filter(item => (data.units_management.currency.data.includes(item.code)));
      data.units_management.currency['currencyList'] = filteredCurrency;
      setUnitData(data);
      
    })
    .catch((error) => {
      console.log(error);
    });
    if(!orderTypesProp){
      const resp = await getMachineGradeSelectForConfig();
        if (!resp.error) {
          // console.log("settings", resp);
          let data = resp?.data?.data?.settings?.order_types;
          const filteredOrderTypes = data?.filter(item => item.value === true && (item.name === "reel" || item.name === "sheet"))
          .map(item => ({ name: item.name, value: item.value })); 
          setOrderTypesData(filteredOrderTypes);
      }
    }
  })();
  }, []);

  useEffect(() => {
    paperMachineListData().then((resp) => {
      // console.log("Machines", resp);
      setMachines(
        resp.map((item) => {
          return { value: item.code, label: item.code };
        })
      );
      setMchinesList(
        resp.map((item) => {
          return { value: item.code, label: item.code + ' - ' + item.name };
        })
      );
    });
    getAllCutter().then((resp) => {
      // console.log("Machines", resp);
      setCutters(
        resp.data.map((item) => {
          return { value: item.code, label: item.code + ' - ' + item.name };
        })
      );
    });
    getAllRewinder().then((resp) => {
      // console.log("Machines", resp);
      setRewinders(
        resp.data.map((item) => {
          return { value: item.code, label: item.code + ' - ' + item.name };
        })
      );
    });
  }, []);

  useEffect(() => {
    getCustomers().then((resp) => {
      // console.log("Customers", resp.map((item) => item.name));
      setCustomers(
        resp.map((item) => {
          return { value: item.name, label: item.name };
        })
      );
    });
  }, []);
  useEffect(() => {
    getProductsData().then((resp) => {
      // console.log("Customers", resp.map((item) => item.name));
      setProducts(
        resp.map((item) => {
          return { value: item.code, label: item.code };
        })
      );
    });
  }, []);

  //multiSelectFilterUpdation
  useEffect(() => {
    if (selectedStates.length) {
      switch (filterType.value) {
        case "country":
          const countryFilter = {
            type: filterType.value,
            country: selectedStates,
          };
          setAppliedFiltersArray(countryFilter);
          break;
        case "status":
          const status =
            selectedStates.length > 1
              ? "both"
              : selectedStates[0] === "Active"
              ? "active"
              : "disabled";
          const statusFilter = { type: filterType.value, status };
          setAppliedFiltersArray(statusFilter);
          break;
          case "category":
          const category =
            selectedStates.length > 1
              ? "both"
              : selectedStates[0] === "Domestic"
              ? "domestic"
              : "export";
          const categoryFilter = { type: filterType.value, category };
          setAppliedFiltersArray(categoryFilter);
          break;
        case "shift":
          const shiftFilter = {
            type: filterType.value,
            shifts: selectedStates,
          };
          setAppliedFiltersArray(shiftFilter);
          break;
        case "statusOpen":
          const openClosedFilter = { type: "status", status: selectedStates };
          setAppliedFiltersArray(openClosedFilter);
          break;
        case "machine":
          const machineFilter = {
            type: filterType.value,
            machines: selectedStates,
          };
          setAppliedFiltersArray(machineFilter);
          break;
        case "order_type":
          const order_type =
            selectedStates.length > 1
              ? "both"
              : selectedStates[0] === "Reel"
              ? "reel"
              : "sheet";
          const orderTypeFilter = { type: filterType.value, order_type };
          setAppliedFiltersArray(orderTypeFilter);
          break;
          case "ply_type":
          const plyTypeFilter = { 
            type: filterType.value, 
            plyTypes: selectedStates
          };
          setAppliedFiltersArray(plyTypeFilter);
          break;
        case "deckle_order_type":
          const deckle_order_type = 
          selectedStates.length > 1
              ? "both"
              : selectedStates[0] === "Unplanned Orders"
              ? "incomplete_orders"
              : "planned_orders";
          const deckleOrderTypeFilter = { type: filterType.value, deckle_order_type };
          setAppliedFiltersArray(deckleOrderTypeFilter);
        case "cutter_type":
            const cutter_type =
              selectedStates.length > 1
                ? "both"
                : selectedStates[0] === "Simplex"
                ? "simplex"
                : "duplex";
            const typeFilter = { type: filterType.value, cutter_type };
            setAppliedFiltersArray(typeFilter);
            break;
            case "machine_type":
          const machine_type =
            selectedStates.length > 1
              ? "both"
              : selectedStates[0] === "Rewinding"
              ? "rewinder"
              : "cutter";
          const machineTypeFilter = { type: filterType.value, machine_type };
          setAppliedFiltersArray(machineTypeFilter);
          break;
        case "orderStatus":
          const orderStatusFilter = {
            type: "status",
            status: selectedStates.map((item) =>
              item === "Open"
                ? "open"
                : item === "Pending"
                ? "pending"
                : item === "Changes Requested"
                ? "review"
                : item === "Approved"
                ? "approved"
                : item === "Rejected"
                ? "rejected"
                : item === "On Hold"
                ? "hold"
                : null
            ),
          };
          setAppliedFiltersArray(orderStatusFilter);
          break;
        case "customer":
          const customerFilter = {
            type: filterType.value,
            names: selectedStates,
          };
          setAppliedFiltersArray(customerFilter);
          break;
        case "consignee":
          const consigneFilter = {
            type: filterType.value,
            names: selectedStates,
          };
          setAppliedFiltersArray(consigneFilter);
          break;
        case "priority":
          const priority =
            selectedStates.length > 1
              ? "both"
              : selectedStates[0] === "Yes"
              ? "yes"
              : "no";
          const priorityFilter = { type: filterType.value, priority: priority };
          setAppliedFiltersArray(priorityFilter);
          break;
        case "role":
          const role =
            selectedStates.length > 1
              ? "BOTH"
              : selectedStates[0] === "Basic"
              ? "BASIC"
              : "ADMIN";
          const roleFilter = { type: filterType.value, role };
          setAppliedFiltersArray(roleFilter);
          break;
          case "item_type":
            const item_type =
              selectedStates.length > 1
                ? "both"
                : selectedStates[0] === "Stock"
                ? "stock"
                : "order";
            const itemTypeFilter = { type: filterType.value, item_type };
            setAppliedFiltersArray(itemTypeFilter);
            break;
        }
      setDisableFilter(false);
    } else setDisableFilter(true);
  }, [selectedStates]);

  useEffect(() => {
    if (selectedGrade) {
      if (selectedQualities && selectedQualities.length && !checkAllQualities) {
        const newGradeFilter = {
          grade: selectedGrade,
          qualities: selectedQualities,
        };
        const tempObj = {
          type: "grade_quality",
          grades: [newGradeFilter],
        };
        setSelectedGradeQualtites(tempObj.grades);
        // console.log("obj", tempObj);
        setAppliedFiltersArray(tempObj);
        setDisableFilter(false);
      } else {
        if (checkAllQualities) {
          const newGradeFilter = {
            grade: selectedGrade,
            qualities: [],
          };
          const tempObj = {
            type: "grade_quality",
            grades: [newGradeFilter],
          };
          setSelectedGradeQualtites(tempObj.grades);
          // console.log("obj", tempObj);
          setAppliedFiltersArray(tempObj);
          setDisableFilter(false);
        }
        else {
          setDisableFilter(true);
        }
      }
    } else {
      setDisableFilter(true);
    }
  }, [selectedQualities]);

  useEffect(() => {
    getAllGrades().then((resp) => {
      // console.log("Grades", resp);
      setSearchedGrades(resp);
      setGrades(resp);
    });
  }, []);

//   useEffect(() => {
//   if (gsmFilterOptions.length > 0 && !hasSetInitialValue && sizeFilterForm) {
//     sizeFilterForm.setFieldsValue({ gsmFilterType: gsmFilterOptions[0].value });
//     setHasSetInitialValue(true);
//   }
//  }, [gsmFilterOptions, hasSetInitialValue, sizeFilterForm]);


  const clearFilters = () => {
    setIndeterminate(false);
    setSelectedStates([]);
    setAppliedFiltersArray([]);
    setSelectedGradeQualtites([]);
  };

  const openQualitiesHandler = (currentGrade) => {
    setSelectedGrade(currentGrade.name);
    // setShowQualities(true);
    getGradeQualities(currentGrade.name).then((resp) => {
      setQualities(resp.map((quality) => quality.name));
      setSearchedQualties(resp.map((quality) => quality.name));
      setShowQualities(true);
      if (resp.length === 0) {
        setDisableFilter(true);
      } else setDisableFilter(true);
    });
  };

  const searchGradeHandler = (e) => {
    if (e.target.value === "") {
      setSearchedGrades(grades);
    } else {
      setSearchedGrades(
        grades.filter((item) =>
          item.name.toLowerCase().includes(e.target.value.toLowerCase())
        )
      );
    }
  };

  const searchQualitiesHandler = (e) => {
    if (e.target.value === "") {
      setSearchedQualties(qualities);
    } else {
      setSearchedQualties(
        qualities.filter((item) =>
          item.toLowerCase().includes(e.target.value.toLowerCase())
        )
      );
    }
  };

  const searchMultiSelectHandler = (e) => {
    if (e.target.value === "") {
      setMultiSelectSearch({
        bool: false,
        searchedOptions: multiSelectEnum[filterType.value].options,
      });
      setSearchedQualties(qualities);
    } else {
      setSearchedQualties(
        qualities.filter((item) =>
          item.toLowerCase().includes(e.target.value.toLowerCase())
        )
      );
      setMultiSelectSearch({
        bool: true,
        searchedOptions: multiSelectEnum[filterType.value].options.filter(
          (item) => item.toLowerCase().includes(e.target.value.toLowerCase())
        ),
      });
    }
  };

  const onFieldsChange = (values, allValues) => {
    if(values[0]?.name[0] == 'machineFilter' && selectedOption && !selectedOption.length)
    {
      setDisableFilter(true);
    }
    else
    allValues.map((item) => {
      if (item.errors.length) {
        setDisableFilter(true);
        return;
      } else setDisableFilter(false);
    });
  };

  const renderSwitch = (type) => {
    switch (type) {
      case "date":
        return (
          <div className="dateRanged">
            <h6 className="filterTitle">
              <Button className="backfilter" onClick={backFilter}>
                <span></span>
              </Button>{" "}
              Filter by Date Range
            </h6>
            <DateRangePicker
              ranges={[dateSelectionRange]}
              onChange={handleDateSelect}
            />
          </div>
        );
      case "grade":
        return (
          <div className="gradeFiltered scrolled-ui">
            <h6 className="filterTitle">
              <Button className="backfilter" onClick={backFilter}>
                <span></span>
              </Button>{" "}
              Filter by Grade
            </h6>
            <Input
              placeholder="Search Grade"
              className="searchFilt"
              onChange={searchGradeHandler}
            />
            <Menu
              selectedKeys={[]}
              //onClick={filterSelect}
            >
              {searchedGrades.map((item) => (
                <Menu.Item
                  onClick={() => openQualitiesHandler(item)}
                  key={item.key}
                >
                  {item.name} <span className="arrowSel"></span>
                </Menu.Item>
              ))}
            </Menu>
            <div
              className={`qualityDroped ${
                // showQualities && qualities?.length ? "qualityEnabled" : ""
                showQualities ? "qualityEnabled" : ""
              }`}
            >
              <div className="gradeFiltered scrolled-ui">
                <h6 className="filterTitle">Select Qualites</h6>
                <Input
                  placeholder="Search Quality"
                  className="searchFilt"
                  onChange={searchQualitiesHandler}
                />
                <Menu selectedKeys={[]}>
                  <HaberForm>
                    {qualities?.length ? (
                      <Form>
                        <div className="all-Qul">
                          <Form.Item
                            name="chkAllProducts"
                            valuePropName=""
                            wrapperCol={{ span: 24 }}
                            className="alignedBox"
                          >
                            <Checkbox
                              indeterminate={qualityIndeterminate}
                              onChange={selectAllQualitiesHandler}
                              checked={checkAllQualities}
                            >
                              Select All products for this grade
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <label className="allQuality">
                          Select specific qualities
                        </label>
                        <div class="checkboxFilt">
                          <Checkbox.Group
                            options={searchedQualities}
                            value={selectedQualities}
                            onChange={checkQualityHandler}
                          />
                        </div>
                      </Form>
                    ) : (
                      <Form>
                        <div className="all-Qul">
                          <Form.Item
                            name=""
                            valuePropName=""
                            wrapperCol={{ span: 24 }}
                            className="alignedBox"
                          >
                            <Checkbox
                              indeterminate={qualityIndeterminate}
                              onChange={selectAllQualitiesHandler}
                              checked={checkAllQualities}
                            >
                              Select All products for this grade
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <label
                          className="allQuality"
                          style={{ paddingTop: "12px" }}
                        >
                          No qualities for this grade
                        </label>
                      </Form>
                    )}
                  </HaberForm>
                </Menu>
              </div>
            </div>
          </div>
        );
      case "inputSelect":
        return (
          <HaberForm className="filterForm filterRanged">
            <h6 className="filterTitle">
              <Button className="backfilter" onClick={backFilter}>
                <span></span>
              </Button>{" "}
              Filter by {filterType.value}
            </h6>
            <Form
              form={filterForm}
              name="basic"
              autoComplete="off"
              className="haberLogin"
              onFieldsChange={onFieldsChange}
            >
              <Form.Item
                name="gsmFilterType"
                className=""
                rules={[
                  {
                    required: type === "inputSelect",
                    message: "This field is required",
                  },
                ]}
                initialValue={gsmFilterOptions[0]?.value}

              >
                <Select
                  suffixIcon={<DownArrowDraw />}
                  onChange={(e) => {
                    console.log("Event", e);
                    setGsmFilterType(e);
                    selectedGsmOptions.current = e;
                  }}
                  showSearch= {true}
                  className={filterType.value}
                  placeholder="Select Range"
                >
                  {gsmFilterOptions.map((item) => (
                    <Option key={item.value}>{item.label}</Option>
                  ))}
                </Select>
              </Form.Item>
              {selectedGsmOptions.current === "in_range" ? (
                <>
                <Row span={24} gutter={8} >
                  <Col span={12} className="d-flex" style={{height: filterType.unitType ? '40px' : ''}}>
                    <Form.Item
                      name="gsmMin"
                      className="removepadd"
                      rules={[
                        {
                          required: type === "inputSelect",
                          message: "This field is required",
                        },
                        {
                          pattern: new RegExp(/^\d+(\.\d+)?$/),
                          message: "Only numerical values are allowed",
                        },
                      ]}
                    >
                      <Input
                        placeholder={`Min. ${filterType.value}`}
                        style={{ paddingLeft: "10px !important" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12} className="d-flex" style={{height: filterType.unitType ? '40px' : ''}}>
                    <Form.Item
                      name="gsmMax"
                      className="removepadd"
                      rules={[
                        {
                          required: type === "inputSelect",
                          message: "This field is required",
                        },
                        {
                          pattern: new RegExp(/^\d+(\.\d+)?$/),
                          message: "Only numerical values are allowed",
                        },
                      ]}
                    >
                      <Input
                        placeholder={`Max. ${filterType.value}`}
                        style={{ paddingLeft: "10px !important" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
               {filterType.unitType && ( <Row span={24} gutter={8}>
                <Col span={24} className="d-flex">
                <Form.Item
                name="unitSelect"
                className=""
                rules={[
                  {
                    required: type === "unitSelect",
                    message: "This field is required",
                  },
                ]}
              >
               <Select
                    suffixIcon={<DownArrowDraw />}
                    // onChange={(e) => {
                    //   console.log("Event", e);
                    //   setGsmFilterType(e);
                    // }}
                    className={filterType.value}
                    placeholder="Select Unit"
                    showSearch = {true}
                  >
                    { filterType.unitType == 'length' ?  unitData.units_management.length.data.map((item) => (
                      <Option key={item}>{lengthUnit[item].displayName}</Option>
                    )) : filterType.unitType == 'weight' ? unitData.units_management.weight.data.map((item) => (
                      <Option key={item}>{weightUnit[item].displayName}</Option> )) : unitData.units_management.currency.currencyList.map((currency) => (
                        <Option key={currency.code}>
                                      <Tooltip title = {currency.displayName}>
                                      {`${currency.code}`}
                                      </Tooltip>
                                    </Option>))}
                  </Select>
              </Form.Item>
              </Col>
              </Row>)}
                </>
              ) : (
                <Row span={24} gutter={8}>
                  <Col span={filterType.unitType ? 12 : 24} className="d-flex">
                <Form.Item
                  name="gsmFilterValue"
                  className="removepadd"
                  rules={[
                    {
                      required: type === "inputSelect",
                      message: "This field is required",
                    },
                    {
                      pattern: new RegExp(/^\d+(\.\d+)?$/),
                      message: "Only numerical values are allowed",
                    },
                  ]}
                >
                  <Input
                    placeholder={`Enter ${filterType.value}`}
                    style={{ paddingLeft: "10px !important" }}
                  />
                </Form.Item>
                </Col>
                {filterType.unitType && ( <Col span={12} className="d-flex" >
                <Form.Item
                name="unitSelect"
                className=""
                rules={[
                  {
                    required: type === "unitSelect",
                    message: "This field is required",
                  },
                ]}
              >
                <Select
                    suffixIcon={<DownArrowDraw />}
                    // onChange={(e) => {
                    //   console.log("Event", e);
                    //   setGsmFilterType(e);
                    // }}
                    className={filterType.value}
                    placeholder="Select Unit"
                    showSearch
                  >
                     { filterType.unitType == 'length' ?  unitData.units_management.length.data.map((item) => (
                      <Option key={item}>{lengthUnit[item].displayName}</Option>
                    )) : filterType.unitType == 'weight' ? unitData.units_management.weight.data.map((item) => (
                      <Option key={item}>{weightUnit[item].displayName}</Option> )) : unitData.units_management.currency.currencyList.map((currency) => (
                        <Option key={currency.code}>
                                      <Tooltip title = {currency.displayName}>
                                      {`${currency.code}`}
                                      </Tooltip>
                                    </Option>))}
                  </Select>
              </Form.Item>
              </Col>)}
              </Row>
              )}
            </Form>
          </HaberForm>
        );
      case "equalInputSelect":
        return (
          <HaberForm className="filterForm filterRanged">
            <h6 className="filterTitle">
              <Button className="backfilter" onClick={backFilter}>
                <span></span>
              </Button>{" "}
              Filter by {filterType.value}
            </h6>
            <Form
              form={filterForm}
              name="basic"
              autoComplete="off"
              className="haberLogin"
              onFieldsChange={onFieldsChange}
            >
              <Form.Item
                name="gsmFilterType"
                className=""
                rules={[
                  {
                    required: type === "equalInputSelect",
                    message: "This field is required",
                  },
                ]}
              >
                <Select
                  suffixIcon={<DownArrowDraw />}
                  onChange={(e) => {
                    console.log("Event", e);
                    setGsmFilterType(e);
                    selectedGsmOptions.current = e;

                  }}
                  className={filterType.value}
                  placeholder="Select Range"
                >
                  {equalFilterOption.map((item) => (
                    <Option key={item.value}>{item.label}</Option>
                  ))}
                </Select>
              </Form.Item>
              {selectedGsmOptions.current === "in_range" ? (
                <Row span={24} gutter={8}>
                  <Col span={12} className="d-flex">
                    <Form.Item
                      name="gsmMin"
                      className="removepadd"
                      rules={[
                        {
                          required: type === "equalInputSelect",
                          message: "This field is required",
                        },
                        {
                          pattern: new RegExp(/^\d+(\.\d+)?$/),
                          message: "Only numerical values are allowed",
                        },
                      ]}
                    >
                      <Input
                        placeholder={`Min. ${filterType.value}`}
                        style={{ paddingLeft: "10px !important" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12} className="d-flex">
                    <Form.Item
                      name="gsmMax"
                      className="removepadd"
                      rules={[
                        {
                          required: type === "equalInputSelect",
                          message: "This field is required",
                        },
                        {
                          pattern: new RegExp(/^\d+(\.\d+)?$/),
                          message: "Only numerical values are allowed",
                        },
                      ]}
                    >
                      <Input
                        placeholder={`Max. ${filterType.value}`}
                        style={{ paddingLeft: "10px !important" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              ) : (
                <Form.Item
                  name="gsmFilterValue"
                  className="removepadd"
                  rules={[
                    {
                      required: type === "equalInputSelect",
                      message: "This field is required",
                    },
                    {
                      pattern: new RegExp(/^\d+(\.\d+)?$/),
                      message: "Only numerical values are allowed",
                    },
                  ]}
                >
                  <Input
                    placeholder={`Enter ${filterType.value}`}
                    style={{ paddingLeft: "10px !important" }}
                  />
                </Form.Item>
              )}
            </Form>
          </HaberForm>
        );

      case "multiSelect":
        return (
          <HaberForm style={{ width: "100%" }}>
            <h6 className="filterTitle">
              <Button className="backfilter" onClick={backFilter}>
                <span></span>
              </Button>{" "}
              {filterType.label}
            </h6>
            {/* <Input
              placeholder={`Search ${
                filterType.label.split("by")[1] ||
                filterType.label.spit("By")[1]
              }`}
              className="searchFilt"
              onChange={searchMultiSelectHandler}
            /> */}
            <Form>
              <div
                className="filterSelectList checkboxFilt"
                style={{ display: "flex", flexDirection: "column", margin : "10px" }}
              >
                {/* <Checkbox
                  indeterminate={indeterminate}
                  onChange={selectAllHandler}
                  checked={checkAllStates}
                >
                  Select all
                </Checkbox>
                <Checkbox.Group
                  options={
                    multiSelectSearch.bool
                      ? multiSelectSearch.searchedOptions
                      : multiSelectEnum[filterType.value].options
                  }
                  value={selectedStates}
                  onChange={(e)=>checkBoxOptionHandler(e)}
                />
               */}
                <MultiSelectHeader>
                  <MultiSelect
                    options={multiSelectEnum[filterType.value].options}
                    value={selectedOption}
                    onChange={checkBoxOptionHandler}
                    valueRenderer={(selected) => {
                      if (!selected.length)
                        return `Search ${
                          filterType.label.split("by")[1] ||
                          filterType.label.spit("By")[1]
                        }`;
                    }}
                  />
                </MultiSelectHeader>
              </div>
            </Form>
          </HaberForm>
        );
      case "rangeTypeSelect":
        return (
          <HaberForm className="filterForm filterRanged">
            <h6 className="filterTitle">
              <Button className="backfilter" onClick={backFilter}>
                <span></span>
              </Button>{" "}
              Filter by Size
            </h6>
            <Form
              form={sizeFilterForm}
              name="basic"
              autoComplete="off"
              className="haberLogin"
              onFieldsChange={onFieldsChange}
            >
              <Form.Item
                name="gsmFilterType"
                className=""
                rules={[
                  {
                    required: type === "rangeTypeSelect",
                    message: "This field is required",
                  },
                ]}
                initialValue={gsmFilterOptions[0]?.value}
              >
                <Select
                  suffixIcon={<DownArrowDraw />}
                  onChange={(e) => {
                    console.log("Event", e);
                    setGsmFilterType(e);
                    selectedGsmOptions.current = e;

                  }}
                  placeholder="Select Range"
                  className={filterType.value}
                >
                  {gsmFilterOptions.map((item) => (
                    <Option key={item.value}>{item.label}</Option>
                  ))}
                </Select>
              </Form.Item>
              {!(orderTypesData?.length == 1 && orderTypesData[0]?.name == "reel") &&
               <Form.Item
                name="sizeType"
                className="removepadd"
                rules={[
                  {
                    required: type === "rangeTypeSelect",
                    message: "This field is required",
                  },
                ]}
              >
                <Select
                  suffixIcon={<DownArrowDraw />}
                  placeholder="Select size type"
                  // onChange={(e) => {
                  //   console.log("Event", e);
                  //   setGsmFilterType(e);
                  // }}
                >
                  {sizeTypeOptions.map((item) => (
                    <Option key={item.value}>{item.label}</Option>
                  ))}
                </Select>
              </Form.Item>
              }
              {selectedGsmOptions.current === "in_range" ? (
                <>
                <Row span={24} gutter={8}>
                  <Col span={12} className="d-flex" style={{height: filterType.unitType ? '40px' : ''}}>
                    <Form.Item
                      name="gsmMin"
                      className="removepadd"
                      rules={[
                        {
                          required: type === "rangeTypeSelect",
                          message: "This field is required",
                        },
                        {
                          pattern: new RegExp(/^\d+(\.\d+)?$/),
                          message: "Only numerical values are allowed",
                        },
                      ]}
                    >
                      <Input placeholder={`Min. ${filterType.value}`} />
                    </Form.Item>
                  </Col>
                  <Col span={12} className="d-flex" style={{height: filterType.unitType ? '40px' : ''}}>
                    <Form.Item
                      name="gsmMax"
                      className="removepadd"
                      rules={[
                        {
                          required: type === "rangeTypeSelect",
                          message: "This field is required",
                        },
                        {
                          pattern: new RegExp(/^\d+(\.\d+)?$/),
                          message: "Only numerical values are allowed",
                        },
                      ]}
                    >
                      <Input placeholder={`Max. ${filterType.value}`} />
                    </Form.Item>
                  </Col>
                </Row>
                {filterType.unitType && ( <Row span={24} gutter={8}>
                <Col span={24} className="d-flex">
                <Form.Item
                name="unitSelect"
                className=""
                rules={[
                  {
                    required: type === "unitSelect",
                    message: "This field is required",
                  },
                ]}
              >
                <Select
                    suffixIcon={<DownArrowDraw />}
                    // onChange={(e) => {
                    //   console.log("Event", e);
                    //   setGsmFilterType(e);
                    // }}
                    className={filterType.value}
                    placeholder="Select Unit"
                    showSearch = {true}
                  >
                     { filterType.unitType == 'length' ?  unitData.units_management.length.data.map((item) => (
                      <Option key={item}>{lengthUnit[item].displayName}</Option>
                    )) : filterType.unitType == 'weight' ? unitData.units_management.weight.data.map((item) => (
                      <Option key={item}>{weightUnit[item].displayName}</Option> )) : unitData.units_management.currency.currencyList.map((currency) => (
                        <Option key={currency.code}>
                                      <Tooltip title = {currency.displayName}>
                                      {`${currency.code}`}
                                      </Tooltip>
                                    </Option>))}
                  </Select>
              </Form.Item>
              </Col>
              </Row>)}
              </>
              ) : (
                <Row span={24} gutter={8}>
                <Col span={filterType.unitType ?  12 : 24} className="d-flex">
                <Form.Item
                  name="gsmFilterValue"
                  className="removepadd"
                  rules={[
                    {
                      required: type === "rangeTypeSelect",
                      message: "This field is required",
                    },
                    {
                      pattern: new RegExp(/^\d+(\.\d+)?$/),
                      message: "Only numerical values are allowed",
                    },
                  ]}
                >
                  <Input placeholder={`Enter ${filterType.value}`} />
                </Form.Item>
                </Col>
                {filterType.unitType && (<Col span={12} className="d-flex" >
                <Form.Item
                name="unitSelect"
                className=""
                rules={[
                  {
                    required: type === "unitSelect",
                    message: "This field is required",
                  },
                ]}
              >
                <Select
                    suffixIcon={<DownArrowDraw />}
                    // onChange={(e) => {
                    //   console.log("Event", e);
                    //   setGsmFilterType(e);
                    // }}
                    className={filterType.value}
                    placeholder="Select Unit"
                    showSearch = {true}
                  >
                     { filterType.unitType == 'length' ?  unitData.units_management.length.data.map((item) => (
                      <Option key={item}>{lengthUnit[item].displayName}</Option>
                    )) : filterType.unitType == 'weight' ? unitData.units_management.weight.data.map((item) => (
                      <Option key={item}>{weightUnit[item].displayName}</Option> )) : unitData.units_management.currency.currencyList.map((currency) => (
                        <Option key={currency.code}>
                                      <Tooltip title = {currency.displayName}>
                                      {`${currency.code}`}
                                      </Tooltip>
                                    </Option>))}
                  </Select>
              </Form.Item>
              </Col>)}
                </Row>
              )}
            </Form>
          </HaberForm>
        );
      case "input":
        return (
          <HaberForm className="filterForm filterRanged">
            <h6 className="filterTitle">
              <Button className="backfilter" onClick={backFilter}>
                <span></span>
              </Button>{" "}
              Filter by Job Card No
            </h6>
            <Form
              form={jobCardForm}
              name="basic"
              autoComplete="off"
              className="haberLogin"
              onFieldsChange={onFieldsChange}
            >
              <Form.Item
                name="gsmFilterValue"
                className="removepadd"
                rules={[
                  {
                    required: type === "input",
                    message: "This field is required",
                  },
                  {
                    pattern: new RegExp(/^[1-9]\d*$/),
                    message: "Only positive numerical values are allowed",
                  },
                ]}
              >
                <Input
                  placeholder={`Enter ${filterType.value}`}
                  style={{ paddingLeft: "10px !important" }}
                />
              </Form.Item>
            </Form>
          </HaberForm>
        );
        case "machineType":
          return (
            <HaberForm className="filterForm filterRanged">
              <h6 className="filterTitle">
                <Button className="backfilter" onClick={backFilter}>
                  <span></span>
                </Button>{" "}
                Filter by {filterType.value}
              </h6>
              <Form
                form={filterForm}
                name="basic"
                autoComplete="off"
                className="haberLogin"
                onFieldsChange={onFieldsChange}
              >
                <Form.Item
                  name="machineFilter"
                  className=""
                  rules={[
                    {
                      required: type === "machineSelect",
                      message: "This field is required",
                    },
                  ]}
                >
                  <Select
                    suffixIcon={<DownArrowDraw />}
                    onChange={(e) => {
                      console.log("Event", e);
                      setMachineFilterType(e);
                      setSelectedOption([]);
                    }}
                    showSearch= {true}
                    className={filterType.value}
                    placeholder="Select Machine Type"
                  >
                    {machineFilterOptions.map((item) => (
                      <Option key={item.value}>{item.label}</Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="machineFilterType"
                  className=""
                  rules={[
                    {
                      required: type === "machineType",
                      message: "This field is required",
                    },
                  ]}
                >
                  <div
                className="filterSelectList checkboxFilt"
                style={{ display: "flex", flexDirection: "column" }}>
                  <MultiSelectHeader>
                  <MultiSelect
                    options={machineFilterType == 'paper_machine' && machinesList.length ? machinesList : machineFilterType == 'rewinder' && rewinders.length ? rewinders :  machineFilterType == 'cutter' && cutters.length ? cutters : [] }
                    value={selectedOption}
                    onChange={machineCheckBoxOptionHandler}
                    valueRenderer={(selected) => {
                      if (!selected.length)
                        return `Select Machines`
                        ;
                    }}
                  />
                </MultiSelectHeader>
                </div>
                </Form.Item>  
              </Form>
            </HaberForm>
          );
       
          default:
        return <></>;
    }
  };

  const onBulkOrderChange = (e) => {
  setOrderType(e.order_type);
  }

  const onBulkDeckleOrderChange = (e) => {
    setDeckleOrderType(e.deckle_order_type);
  }

  const handleReelTypeChange = (e) => {
    onReelTypeChange(e.target.value);
  }

  return (
    <SearchBarHeader>
      <div className={`searchBoxWrap ${hideSearch ? "jobCardSearchWrap" : ""}`} style={{ padding: isOtherFilter? '0px': '',justifyContent : showBulkOrderUpdate ? "normal" : ''}}>
        {!hideSearch && !isOtherFilter && (
          <HaberForm className="searchWidth"
          style = {{width : ismachineOrderSearch ? '62%':  showBulkOrderUpdate ? "50%" :  isPendingTab && !showBulkOrderUpdate ? "60%": jumboReelSearch ? "52%" :isSelectedOrder ? '42%':''}}
          >
            <Form
              form={form}
              name="basic"
              autoComplete="off"
              className="haberLogin"
            >
              <Form.Item
                name="username"
                className="searchIcon"
                rules={[{ required: "" }]}
                initialValue={searchedValue ? searchedValue : ""}
              >
                <Input
                  placeholder={placeholder}
                  onChange={(e) => {
                    debounceOnChange(e.target.value);
                  }}
                  onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
                  disabled={isDisabled}
                />
              </Form.Item>
            </Form>
          </HaberForm>
        )}
       
        {/* <div ref={filterRef}> */}
        {(filterOptions && filterOptions?.length) && (
          <div ref={filterRef} className="filterParent" style={{marginRight : showBulkOrderUpdate ? "0px":'' }}>
            {/* <Dropdown
              overlay={filterDropDown}
              trigger={["click"]}
              className="filterDropDown"
            > */}
            <Button
              className="filterBtn "
              onClick={showFilterDropDown}
              disabled={filterBtnDisable}
              style = {{minWidth : isOtherFilter? '0px': '',padding:isOtherFilter? '0px 2px': ''}}
            >
              <Iconmoon icon="filter" size={15} color="#605E5C" />
             {isOtherFilter ? "Other Filters" : "Filter"} 
            </Button>
            {/* </Dropdown> */}
            <div className="filterDropDown">
              <FilterComp
                visible={showFilterOptions}
                onCancel={closeFilterDropDown}
                className={`filterTypeSelect  ${
                  showFilterOptions ? "visibleTrue" : ""
                }`}
              >
                <FilteredGrid>
                  <div className="MainFiltered scrolled-ui">
                    <h6 className="filterTitle">Select Filter Type</h6>
                    <Menu selectedKeys={[]} onClick={filterSelect}>
                      {/* <Input placeholder="Filter Products" /> */}
                      {filterOptions.map((item) => (
                        <Menu.Item key={item.key}>{item.label}</Menu.Item>
                      ))}
                    </Menu>
                  </div>
                </FilteredGrid>
              </FilterComp>
              {filterType && (
                <FilterComp
                  visible={filterType}
                  className={`filterDetailsModal filterTypeSelect ${
                    filterType.value
                  } ${filterType ? "visibleTrue" : ""}`}
                  title={
                    <FilteredGrid>
                      <div className="filterHeader">
                        <button
                          className="filterBackBtn"
                          onClick={() => {
                            closeFilterDetails();
                            showFilterDropDown();
                          }}
                        >
                          B
                        </button>
                        {filterType.label}
                      </div>
                    </FilteredGrid>
                  }
                  onCancel={closeFilterDetails}
                >
                  {renderSwitch(filterType.type)}
                  <div className="ant-modal-footer-section filterBtmClick">
                    <Button
                      key="back"
                      className="themeBtn-plane"
                      onClick={clearHandler}
                    >
                      <Iconmoon icon="wrong" size={13} color="#ea655b" /> Clear
                    </Button>
                    <Button
                      key="submit"
                      className="themeBtn"
                      onClick={() => applyFilterHandler()}
                      disabled={disableFilter}
                    >
                      <Iconmoon icon="correct" size={13} color="#ffffff" />{" "}
                      Filter
                    </Button>
                  </div>
                </FilterComp>
              )}
            </div>
          </div>
        )}
        {isPendingTab && showBulkOrderUpdate && (<OrderFilter 
        
                filterType={{
                  key: 0,
                  label: "Filter by Order Type",
                  value: "order_type",
                  type: "multiSelect",
                  name: selectedOrderType,
                }}
                applyFilter={onBulkOrderChange}
                showBulkOrderUpdate = {showBulkOrderUpdate}
              ></OrderFilter>)}

          {isPendingTab && showBulkOrderUpdate && (<OrderFilter
          style={{}}
            filterType={{
              key: 1,
              label: "Filter by Order Type",
              value: "deckle_order_type",
              type: "multiSelect",
              name: deckleOrderType,
            }}
            applyFilter={onBulkDeckleOrderChange}
            buttonType={"deckleOrders"}
            showBulkOrderUpdate = {showBulkOrderUpdate}
          ></OrderFilter>)}
         {/* <TableList>
                      <div style={{ zIndex: 10 }}>
                        <div className="table-view">
                          <HaberForm> */}
                         {selectedReelType &&    <RadioButtonStyle>
                            <RadioGoupStyle>
                              <div
                                className="boxFormType switchRadio"
                                style={{
                                  paddingRight : '30px',
                                }}
                              >
                              
                                <Radio.Group
                                  options={filterViewData}
                                  onChange={handleReelTypeChange}
                                  value={
                                    selectedReelType
                                  }
                                  optionType="button"
                                  buttonStyle="solid"
                                  className={
                                    selectedReelType == 'both'
                                      ? "allActive"
                                      : selectedReelType == 'intermediate' ?
                                      "sheetActive"
                                      : "jcActive"
                                  }
                                  style={{display: "flex", flexDirection: "row"}}
                                />
                                
                              </div>
                              </RadioGoupStyle>
                            </RadioButtonStyle> }
                          {/* </HaberForm>
                        </div>
                       
                      </div>
                    </TableList> */}
          {
            showModifiedDateFilter && 
            (<div className="filterParent" style={{marginRight:"7px"}} >
              <div className="modifiedDateFilterButton" onClick={()=>setDatePickerVisible(!isDatePickerVisible)}>
                <span>Modified: {modifiedFilterLabel}</span>
                < Iconmoon icon="down" size={24}/>
              </div>
              <div>
                <FilterComp
                ref={filterModalRef}
                style={{width:"410px"}}
                visible={isDatePickerVisible}
                onCancel={closeFilterDropDown}
                className={`filterTypeSelect  ${
                  isDatePickerVisible ? "visibleTrue" : ""
                }`}
                >
                  <FilteredGrid>
                    <div className="MainFiltered scrolled-ui ">
                      <h6 className="filterTitle">Select Modified Date Range</h6>
                      <DateRangePicker
                        style={{width:"max-content"}}
                        ranges={[dateRangeForModifiedFilter]}
                        onChange={(ranges)=>{
                          setDateRangeForModifiedFilter({
                            startDate: ranges.selection.startDate,
                            endDate: ranges.selection.endDate,
                            key: "selection",
                          });
                        }}
                        staticRanges={createStaticRanges(customRanges)}
                      />
                      <div className="ant-modal-footer-section filterBtmClick" style={{backgroundColor:"#fff",boxShadow: "2px 4px 14px -3px rgba(0, 0, 0, 0.2)", borderBottomLeftRadius:"8px",borderBottomRightRadius:"8px"}}>
                        <Button
                          key="back"
                          className="themeBtn-plane"
                          onClick={()=>{
                            setDatePickerVisible(false);
                          }}
                        >
                          <Iconmoon icon="wrong" size={13} color="#ea655b" /> Clear
                        </Button>
                        <Button
                          key="submit"
                          className="themeBtn"
                          onClick={() => applyModifiedDateFilterHandler()}
                          disabled={!(dateRangeForModifiedFilter.endDate)}
                        >
                          <Iconmoon icon="correct" size={13} color="#ffffff" />{" "}
                          Filter
                        </Button>
                      </div>
                    </div>
                  </FilteredGrid>
                </FilterComp>
              </div>
            </div>)
          }
        </div>
        <div style={{ display: "flex" }}>
          {/* {isUpdateOrderDetailsInBulkVisible && (
            <div className="exportDataBtn">
              <Button
                onClick={updateButtonClick}
                className="themeBtn noBg"
                disabled={!isUpdateOrderDetailsButtonEnable}
              >
                <Iconmoon icon="edit" size={16} color="#ea655b" /> Update
                Details
              </Button>
            </div>
          )} */}
           
          {isPendingTab && isUpdateOrderDetailsInBulkVisible && (
            <div className="exportDataBtn">
              <Button
                onClick={onShowOrders}
                className="themeBtn noBg"
                //disabled={!isUpdateOrderDetailsButtonEnable}
              >
                {isAllOrder ? "Show Unplanned Orders" : "Show All Orders"}
              </Button>
            </div>
          )}
         
          {isPendingTab && isUpdateOrderDetailsInBulkVisible && (
            <div className="exportDataBtn">
              <Button
                onClick={updateButtonClick}
                className="themeBtn noBg"
                //disabled={!isUpdateOrderDetailsButtonEnable}
              >
                 Update Rewinding
                Details
              </Button>
            </div>
          )}
        {/* </div> */}
        <div style={{ display: "flex" }}>
          {isAddRewinderDetailsPressed && (
            <div className="exportDataBtn">
              <Button onClick={cancelButtonClick} className="textTypeBtn">
                <Iconmoon icon="" size={16} color="#ea655b" /> Cancel Changes
              </Button>
            </div>
          )}
        </div>
        <div style={{ display: "flex" }}>
          {isAddRewinderDetailsPressed && (
            <div className="exportDataBtn">
              <Button onClick={reviewAndUpdateClick} disabled = {isDisableSave} className="themeBtn noBg">
                <Iconmoon icon="addcircle" size={16} color="#ea655b" /> Save
                Changes
              </Button>
            </div>
          )}
        </div>

        <div style={{ display: "flex" }}>
          {isShowCancelButton && (
            <div className="exportDataBtn">
              <Button onClick={cancelButtonClick} className="textTypeBtn">
                <Iconmoon icon="" size={16} color="#ea655b" /> Cancel Changes
              </Button>
            </div>
          )}
        </div>
        <div style={{ display: "flex" }}>
          {isShowReviewAndUpdateButton && (
            <div className="exportDataBtn">
              <Button onClick={reviewAndUpdateClick} disabled = {isDisableSave} className="themeBtn noBg">
                <Iconmoon icon="addcircle" size={16} color="#ea655b" /> Save
                Changes
              </Button>
            </div>
          )}
        </div>
        <div style={{ display: "flex" }}>
          {closeMappingRole && (
            <div className="exportDataBtn">
              <Button disabled = {jumboStatus === 'closed'} onClick={closeMapping} className="themeBtn noBg">
                <Iconmoon icon="file-view" size={16} color="#ea655b" /> Close
                Jumbo for Mapping
              </Button>
            </div>
          )}
          {!hideExport &&
            <div className="exportDataBtn">
              <Button onClick={exportTrigger} className="themeBtn noBg" disabled={!exportRole}>
                <Iconmoon icon="export" size={16} color="#ea655b" /> Export
              </Button>
            </div>
          }
        </div>
        {isAddRewinderDimension && (
        <div style={{ display: "flex" }}>
            <div className="exportDataBtn">
              <Button onClick={onAddRewinderDimension} disabled = {isDisableSave} className="themeBtn noBg">
                <Iconmoon icon="addcircle" size={16} color="#ea655b" /> Add Rewinder Dimension
              </Button>
            </div>
        </div>)}

    {isMoveToSelection && (
        <div style={{ display: "flex" }}>
            <div className="exportDataBtn">
              <Button onClick={onMoveToSelection} disabled = {!selectedRowKeys.length} className="themeBtn">
                <Iconmoon icon="addcircle" size={16} color="#ffffff" /> Move to Selected Orders
                
              </Button>
            </div>
        </div>)}
    
        <div style={{ display: "flex" }}>
          {productRecordRole && (
            <div>
              <Button key="2" className="themeBtn" onClick={addNewSizeClick}>
                <Iconmoon icon="addcircle" size={14} color="#ffffff" />
                Add a new size
              </Button>
            </div>
          )}
        </div>
        
      </div>
    </SearchBarHeader>
  );
};
export default SearchContainer;